import { createAsyncThunk } from '@reduxjs/toolkit';
import { rootSchema, contentType, contactsType } from '../model/types';
import { apiRequest } from '@shared/api/corsProxy';
import { buildingType } from '@/entities/knowledge/model/types';

interface Data {
  data: {
    id: string | undefined;
    homePage: contentType;
    contacts: contactsType;
    buildings: buildingType[];
    footer: {
      legal: {
        linksText: { href: string; label: string }[];
        disclaimer: string;
        consentNotice: string;
      };
    };
  };
}
export const fetchContent = createAsyncThunk<
  contentType,
  void,
  {
    rejectValue: string;
  }
>('content/fetchContent', async (_, { rejectWithValue }) => {
  try {
    const response = await apiRequest<Data>('/data/v2/type?type=commerce');
    // 'https://api.krasota.agency/data/v2/type?type=commerce'
    // Handle case where data might be at root level or nested
    const dataToValidate = response?.data || response;
    const parsed = rootSchema.safeParse(dataToValidate);
    if (!parsed.success) {
      console.error(parsed.error.format());
      return rejectWithValue('Ошибка валидации данных с сервера');
    }

    return parsed.data;
  } catch (error: any) {
    return rejectWithValue(error?.message || 'Ошибка загрузки данных');
  }
});
